import type { InvoiceVatBreakdownRow } from "../api/types";

/**
 * D-84 (owner, 2026-10-03): the per-rate rows under "Document totals" repeat
 * the totals when a paper prints one rate (every Deco paper), so they show
 * only when there are two or more — a Flore or VerdNatura paper with flowers
 * at 10 % and hard goods at 21 %, where the split is the only place that
 * says which part is which.
 */
export function showsRateRows(
  rows: ReadonlyArray<Pick<InvoiceVatBreakdownRow, "ratePercent">>,
): boolean {
  return rows.length > 1;
}
